import {getSportsAsync} from "../actions";
import {createReducer} from "typesafe-actions";
import {SportTreeElement} from "../../../models/api/codegen/code";

export const sports = createReducer([] as SportTreeElement[])
    .handleAction(getSportsAsync.success, (state: SportTreeElement[], action: { payload: SportTreeElement[] }): SportTreeElement[] => action.payload);

